import styled from '@emotion/styled';
import { breakpoints } from '@naf/theme';

type ArticleBlockContentGridColWidth = 'content' | 'full';

export const ArticleBlockContentGridCol = styled.div<{
  $width?: ArticleBlockContentGridColWidth;
}>`
  && {
    max-width: 100%;
    grid-column: ${({ $width = 'content' }) => ($width === 'full' ? '1 / -1' : '3 / -3')};
  }

  @media (max-width: ${breakpoints.m}) {
    && {
      grid-column: 1 / -1;
    }
  }
`;
